import { RouteRecordRaw } from 'vue-router';
import { NotFoundPage } from '@/pages/not-found';

export const routeName = 'NotFound';

export const route: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: routeName,
  component: NotFoundPage,
};
